export const RESET_MODAL = 'RESET_MODAL';
export const RESET_ACCOUNT_USER = 'RESET_ACCOUNT_USER';
export const RESET_MODAL_FILE = 'RESET_MODAL_FILE';

export const FETCH_ACCOUNT_USER_INIT = 'FETCH_ACCOUNT_USER_INIT';
export const FETCH_ACCOUNT_USER_SUCCESS = 'FETCH_ACCOUNT_USER_SUCCESS';
export const FETCH_ACCOUNT_USER_FAILURE = 'FETCH_ACCOUNT_USER_FAILURE';

export const FETCH_ACCOUNT_USER_COUNT_INIT = 'FETCH_ACCOUNT_USER_COUNT_INIT';
export const FETCH_ACCOUNT_USER_COUNT_SUCCESS = 'FETCH_ACCOUNT_USER_COUNT_SUCCESS';
export const FETCH_ACCOUNT_USER_COUNT_FAILURE = 'FETCH_ACCOUNT_USER_COUNT_FAILURE';

export const FETCH_ACCOUNT_USER_ROLL_INIT = 'FETCH_ACCOUNT_USER_ROLL_INIT';
export const FETCH_ACCOUNT_USER_ROLL_SUCCESS = 'FETCH_ACCOUNT_USER_ROLL_SUCCESS';
export const FETCH_ACCOUNT_USER_ROLL_FAILURE = 'FETCH_ACCOUNT_USER_ROLL_FAILURE';

export const FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT = 'FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT';
export const FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS = 'FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS';
export const FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE = 'FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE';

export const FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT = 'FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT';
export const FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS = 'FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS';
export const FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE = 'FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE';

export const FETCH_ACCOUNT_USER_NO_LOADING_INIT = 'FETCH_ACCOUNT_USER_NO_LOADING_INIT';
export const FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS = 'FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS';
export const FETCH_ACCOUNT_USER_NO_LOADING_FAILURE = 'FETCH_ACCOUNT_USER_NO_LOADING_FAILURE';

export const SAVE_ACCOUNT_USER_INIT = 'SAVE_ACCOUNT_USER_INIT';
export const SAVE_ACCOUNT_USER_SUCCESS = 'SAVE_ACCOUNT_USER_SUCCESS';
export const SAVE_ACCOUNT_USER_FAILURE = 'SAVE_ACCOUNT_USER_FAILURE';

export const UPDATE_ACCOUNT_USER_INIT = 'UPDATE_ACCOUNT_USER_INIT';
export const UPDATE_ACCOUNT_USER_SUCCESS = 'UPDATE_ACCOUNT_USER_SUCCESS';
export const UPDATE_ACCOUNT_USER_FAILURE = 'SAVE_ACCOUNT_USER_FAILURE';

export const UPDATE_ACCOUNT_USER_PASS_INIT = 'UPDATE_ACCOUNT_USER_PASS_INIT';
export const UPDATE_ACCOUNT_USER_PASS_SUCCESS = 'UPDATE_ACCOUNT_USER_PASS_SUCCESS';
export const UPDATE_ACCOUNT_USER_PASS_FAILURE = 'SAVE_ACCOUNT_USER_PASS_FAILURE';

export const DELETE_ACCOUNT_USER_INIT = 'DELETE_ACCOUNT_USER_INIT';
export const DELETE_ACCOUNT_USER_SUCCESS = 'DELETE_ACCOUNT_USER_SUCCESS';
export const DELETE_ACCOUNT_USER_FAILURE = 'DELETE_ACCOUNT_USER_FAILURE';

export const ACTIVE_ACCOUNT_USER_INIT = 'ACTIVE_ACCOUNT_USER_INIT';
export const ACTIVE_ACCOUNT_USER_SUCCESS = 'ACTIVE_ACCOUNT_USER_SUCCESS';
export const ACTIVE_ACCOUNT_USER_FAILURE = 'ACTIVE_ACCOUNT_USER_FAILURE';

export const FETCH_DOWNLOAD_ACCOUNT_USER_INIT = 'FETCH_DOWNLOAD_ACCOUNT_USER_INIT';
export const FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS = 'FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS';
export const FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE = 'FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE';

export const FETCH_UPLOAD_ACCOUNT_USER_INIT = 'FETCH_UPLOAD_ACCOUNT_USER_INIT';
export const FETCH_UPLOAD_ACCOUNT_USER_SUCCESS = 'FETCH_UPLOAD_ACCOUNT_USER_SUCCESS';
export const FETCH_UPLOAD_ACCOUNT_USER_FAILURE = 'FETCH_UPLOAD_ACCOUNT_USER_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/account_user/types.js